// staging: wss://stagingservice.dentagenix.com/   live: wss://service.dentagenix.com/
// const ServicePath = process.env.REACT_APP_WS_URL as string
// const ServicePath = "ws://localhost:9015/"
const ServicePath = "wss://stagingservice.dentagenix.com/"
// const ServicePath = "wss://service.dentagenix.com/"

export default ServicePath
